import { gql } from '@apollo/client';

export const QUERY = gql`
  query DepositReport(
    $organizationId: Int!
    $startDate: String!
    $endDate: String!
    $dateColumn: String!
  ) {
    depositFinancialReport(
      input: {
        startDate: $startDate
        endDate: $endDate
        dateColumn: $dateColumn
      }
      organizationId: $organizationId
    ) {
      depositDate
      depositId
      merchantAccountDisplayName
      type
      grossAmount
      status
      netAmount
      fees
    }
  }
`;

